import { render, staticRenderFns } from "./DipsDialog.vue?vue&type=template&id=0c3ffb3b&scoped=true"
import script from "./DipsDialog.vue?vue&type=script&lang=js"
export * from "./DipsDialog.vue?vue&type=script&lang=js"
import style0 from "./DipsDialog.vue?vue&type=style&index=0&id=0c3ffb3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ffb3b",
  null
  
)

export default component.exports